import LeadAssignmentGroupsCRUDActions from '../actions/LeadAssignmentsGroupCRUDActions';
import Actions from '../actions/actions';
import { setBusy, setUnBusy } from './common/commonReducers';
import {
  LeadAssignmentGroup,
  LeadAssignmentGroupsState,
} from '../interfaces/leadAssignmentGroups';

const initialState: LeadAssignmentGroupsState = {
  busy: false,
  entities: [],
};

const retrievedAll = (
  state: LeadAssignmentGroupsState,
  action: { entities: LeadAssignmentGroup[] },
) => {
  const { entities } = action;
  return {
    ...state,
    entities,
    busy: false,
  };
};

export default function leadAssignmentGroups(
  state = initialState,
  action: any,
) {
  switch (action.type) {
    case LeadAssignmentGroupsCRUDActions.busyAction:
      return setBusy(state);
    case LeadAssignmentGroupsCRUDActions.unbusyAction:
      return setUnBusy(state);
    case LeadAssignmentGroupsCRUDActions.retrievedAllAction:
      return retrievedAll(state, action);
    case Actions.RESET:
      return initialState;
    case Actions.UNBUSY:
      return { ...state, busy: false };
    default:
      return state;
  }
}
